import SharesLayout from "../../layout/shares";
import PostView from "./pages/post-view";
import SpaceView from "./pages/space-view";
import NotFound from "./components2/not-found.vue";
export default [
  {
  path: "*",
  component: NotFound
  },
  {
    path: "/m/:postID",
    component: PostView,
    name: "post-view",
    props: (route) => ({
      postID: route.params.postID,
    }),
    meta: {
      requiresAuth: false,
      layout: SharesLayout,
    },
  },
  {
    path: "/x/:postID",
    component: PostView,
    name: "gray-post-view",
    meta: {
      requiresAuth: false,
      layout: SharesLayout,
    },
    props: (route) => ({
      postID: route.params.postID,
      gray: true,
    }),
  },
  {
    path: "/z/:zip",
    component: SpaceView,
    name: "space-view",
    props: true,
    meta: {
      requiresAuth: false,
      layout: SharesLayout,
    },
  },
];
